import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'orbit-dialog-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dialog-footer.component.html',
  styleUrl: './dialog-footer.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogFooterComponent {
  rounded = input<boolean, unknown>(false, { transform: booleanAttribute });
}
